import React, { useEffect, Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import SmoothScroll from "./components/SmoothScroll";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PasswordGate from "./components/PasswordGate";
import HomePage from "./pages/HomePage";
import MethodPage from "./pages/MethodPage";
import ServicesPage from "./pages/ServicesPage";
import StudioPage from "./pages/StudioPage";
import FAQPage from "./pages/FAQPage";
import EnquiryPage from "./pages/EnquiryPage";
import ImpressumPage from "./pages/ImpressumPage";
import { LanguageProvider } from "./i18n/LanguageContext";

// Internal-only route; lazy-loaded so it doesn't ship in the initial bundle.
const TypeSpecimen = lazy(() => import("./pages/TypeSpecimen"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <PasswordGate>
        <div className="App">
          <BrowserRouter>
            <SmoothScroll>
              <ScrollToTop />
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/method" element={<MethodPage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/studio" element={<StudioPage />} />
                  <Route path="/faq" element={<FAQPage />} />
                  <Route path="/enquiry" element={<EnquiryPage />} />
                  <Route path="/impressum" element={<ImpressumPage />} />
                  <Route
                    path="/type"
                    element={
                      <Suspense fallback={null}>
                        <TypeSpecimen />
                      </Suspense>
                    }
                  />
                </Routes>
              </main>
              <Footer />
            </SmoothScroll>
          </BrowserRouter>
          <Toaster
            position="bottom-center"
            theme="light"
            toastOptions={{
              style: {
                background: "#EFECE6",
                color: "#4c535a",
                border: "1px solid rgba(85,107,78,0.3)",
                fontFamily: "Manrope, sans-serif",
                borderRadius: 0,
              },
            }}
          />
        </div>
      </PasswordGate>
    </LanguageProvider>
  );
}

export default App;
